import * as React from 'react';
import * as VerifyDeviceActions from 'user/VerifyDeviceActions';
import { ConfirmableDeviceType } from 'entities/Device';
import { SendType } from 'user/components/LinkDeviceVerificationCodeBox';
import LinkDeviceVerificationCodeBox from 'user/components/LinkDeviceVerificationCodeBox';
import PusherClient from 'pusher/PusherClient';

export type Props = {
  sendType: SendType;
  deviceAddress: string;
  deviceType: ConfirmableDeviceType;
  footer?: React.ReactNode;
  skipUpdateDevicePreferences?: boolean;
  onResend: () => void;
  onDeviceVerified: () => void;
  onDeviceExists: (claimToken: string) => void;
  usingMagicLink?: boolean;
  pollingSecret: string | null;
  pusherChannel: string | null;
};

const subscribeToMagicLinkPushNotification = ({
  pusherChannel,
  pollingSecret,
  onSuccess,
}: {
  pusherChannel: string;
  pollingSecret: string;
  onSuccess: () => void;
}) => {
  PusherClient.subscribe(pusherChannel)
    .then((channel) => {
      channel.bind_all((type: string, eventData: any) => {
        if (type === 'v3.changeset') {
          if (eventData.changes[0].token === pollingSecret) {
            onSuccess();
          }
        }
      });
    })
    .catch((err) => console.error('MagicLinkPoller', err));
};

export default class VerifyDeviceCodeContainer extends React.Component<Props, {}> {
  componentDidMount() {
    const { pusherChannel, pollingSecret } = this.props;
    if (pusherChannel && pollingSecret) {
      subscribeToMagicLinkPushNotification({
        pusherChannel,
        pollingSecret,
        onSuccess: () => {
          this.verifyDeviceCode(pollingSecret);
        },
      });
    }
  }

  componentWillUnmount() {
    const { pusherChannel } = this.props;
    pusherChannel && PusherClient.unsubscribe(pusherChannel);
  }

  verifyDeviceCode = async (code: string) => {
    const resp = await VerifyDeviceActions.verifyDeviceCode(this.props.deviceAddress, code);
    if (resp) {
      const { verifyDeviceForAccountMerge } = resp;
      if (verifyDeviceForAccountMerge.__typename === 'Device') {
        this.props.onDeviceVerified();
      } else {
        this.props.onDeviceExists(verifyDeviceForAccountMerge.token);
      }
    }
  };

  render() {
    return (
      <LinkDeviceVerificationCodeBox
        skipUpdateDevicePreferences={this.props.skipUpdateDevicePreferences}
        onSubmit={this.verifyDeviceCode}
        submittedAddress={this.props.deviceAddress}
        onResend={this.props.onResend}
        footer={this.props.footer}
        deviceType={this.props.deviceType}
        sendType={this.props.sendType}
        usingMagicLink={this.props.usingMagicLink}
      />
    );
  }
}
